import { Navigate, Outlet } from 'react-router-dom';
import { isFullAdminAccount } from 'src/lib/auth/roles';
import { getUser } from 'src/lib/fetch';

export function FullAdminRoute() {
  return isFullAdminAccount(getUser()) ? <Outlet /> : <Navigate to="/admin/areas" replace />;
}
